import script from "./PUR03_006INS.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR03_006INS.vue?vue&type=script&setup=true&lang=js"

import "./PUR03_006INS.vue?vue&type=style&index=0&id=74f32c73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74f32c73"]])

export default __exports__